import { AI_MAX_WH } from "@/utils/constants";
import { Editor_Words } from "@/utils/lang/editor";
import { langStore, translate, useSelecting } from "@noli/business";
import { useMemo } from "react";

type ImgSize = {
  w: number;
  h: number;
};
export type UseSelectedImgSizeProps = {
  maxResolution?: ImgSize;
  defaultResolution?: ImgSize;
};

export function useSelectedImgSize(config?: UseSelectedImgSizeProps) {
  const {
    maxResolution = {
      w: AI_MAX_WH,
      h: AI_MAX_WH,
    },
    defaultResolution = {
      w: 512,
      h: 512,
    },
  } = config ?? {};
  const info = useSelecting("basic")({ fixed: 0 });
  const { type, displayNode, imgWH } = info ?? {};
  const sizeString = useMemo(() => {
    if (type === "path") return `${defaultResolution.w} × ${defaultResolution.h} px`;

    if (imgWH && imgWH.w * imgWH.h > maxResolution.w * maxResolution.h) {
      return "当前尺寸太大";
    }
    return imgWH
      ? `${imgWH.w} × ${imgWH.h} px`
      : translate(Editor_Words["general-loading"], langStore.tgt);
  }, [imgWH, type]);

  return {
    sizeString,
    imgWH,
    displayNode,
  };
}
